import { Row, Col, Typography } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { getAnalytics, logEvent } from "firebase/analytics";

import i18n from "i18next";
import { Extra } from "./styles";
import { socialLinksEn, socialLinksCn } from "./socialLinks";

const Footer = ({ t }: { t: TFunction }) => {
  const socialLinks = i18n.language === "en" ? socialLinksEn : socialLinksCn;

  const handleBackToTopClick = () => {
    const analytics = getAnalytics();
    logEvent(analytics, "back_to_top_clicked");
  };

  const handleSocialClick = (platform: string) => {
    const analytics = getAnalytics();
    logEvent(analytics, "social_clicked", { platform });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer bg-white text-black pt-8">
      <Extra>
        <Container border={true}>
          <Row justify="space-between" align="top">
            <Col flex="1">
              <div style={{ textAlign: "left" }}>
                <Typography.Text>
                  {i18n.language === "en"
                    ? "Tuyou Computing © 2026"
                    : "图优运算 © 2026"}
                </Typography.Text>
                <br />
                <Typography.Link
                  href="https://beian.miit.gov.cn/"
                  target="_blank"
                  className={
                    i18n.language === "en" ? "icp-link" : "icp-link-black"
                  }
                >
                  {"沪ICP备2024064397号"}
                </Typography.Link>
                <br />
                {i18n.language !== "en" && (
                  <a
                    href="https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020240304142953000011776659-SAIC_SHOW_310000-31681d5557b24d0fb92005435b545b7e676&signData=MEUCIHUm6rOT/Mr6YrZ10Ii/irH1kah2sty/rJ9gLkGyM8i+AiEAw/bGGgxeJck653GR8pkeyfedVzkN8wMa15Ktb2Ln05c="
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block"
                    }}
                  >
                    <img
                      src="/digital-license.png"
                      alt="电子营业执照"
                      style={{
                        height: "40px",
                        width: "auto",
                        display: "block"
                      }}
                    />
                  </a>
                )}
              </div>
            </Col>
            <Col flex="auto" style={{ textAlign: "center" }}>
              <button
                onClick={() => {
                  handleBackToTopClick();
                  scrollToTop();
                }}
                className="back-to-top"
              >
                {i18n.language === "en" ? "Back to top ↑" : "回到顶部 ↑"}
              </button>
            </Col>
            <Col flex="1">
              <div className="social-links">
                <Typography.Text>
                  {i18n.language === "en" ? "Follow us" : "关注我们"}
                </Typography.Text>
                {socialLinks.map((social) => (
                  <a
                    key={social.key}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    onClick={() => handleSocialClick(social.key)}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d={social.path} />
                    </svg>
                  </a>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </Extra>
    </footer>
  );
};

export default withTranslation()(Footer);
